import { infraTypes } from '@/statics/constants/infraTypes';
export let colorAssignments = {};
export let availableColors = [
	'#c33d69',
	'#3759ce',
	'#962249',
	'#6237a7',
	'#a84401',
	'#273ea5',
	'#780d35',
	'#03524a',
	'#4a238b',
	'#7e3103',
	'#1b2b88',
	'#003e38',
	'#602400',
	'#a32952',
	'#0d7d70',
	'#6b40b2',
	'#bc4d01',
	'#2c46b1',
	'#81143b',
	'#045b52',
	'#512994',
	'#8a3603',
	'#2ea597',
	'#688ae8',
	'#9469d6',
	'#8456ce',
	'#ce567c',
	'#096f64',
	'#e07941',
	'#4066df',
];

export function resetColorPalette() {
	availableColors = [
		'#c33d69',
		'#3759ce',
		'#962249',
		'#6237a7',
		'#a84401',
		'#273ea5',
		'#780d35',
		'#03524a',
		'#4a238b',
		'#7e3103',
		'#1b2b88',
		'#003e38',
		'#602400',
		'#a32952',
		'#6b40b2',
		'#bc4d01',
		'#2c46b1',
		'#81143b',
		'#045b52',
		'#512994',
		'#8a3603',
		'#2ea597',
		'#688ae8',
		'#9469d6',
		'#8456ce',
		'#0d7d70',
		'#ce567c',
		'#e07941',
		'#4066df',
		'#096f64',
	];
	colorAssignments = {};
}

/**
 * Generate a random color
 */
function generateRandomColor() {
	const r = Math.floor(Math.random() * 256);
	const g = Math.floor(Math.random() * 256);
	const b = Math.floor(Math.random() * 256);
	return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
}

export function generateColor(paramId, sourceId = '') {
	const key = `${paramId}_${sourceId}`;

	if (colorAssignments[key]) {
		return colorAssignments[key];
	}

	let assignedColor;

	if (availableColors.length > 0) {
		assignedColor = availableColors.shift();
	} else {
		assignedColor = generateRandomColor();
	}

	colorAssignments[key] = assignedColor;
	return assignedColor;
}

/**
 * Convierte un color hexadecimal a formato RGBA
 */
export function hexToRgba(hex, alpha = 0.3) {
	if (!hex) return 'rgba(0, 0, 0, 0.3)';

	let r = 0,
		g = 0,
		b = 0;

	if (hex.length === 4) {
		r = parseInt(hex[1] + hex[1], 16);
		g = parseInt(hex[2] + hex[2], 16);
		b = parseInt(hex[3] + hex[3], 16);
	} else if (hex.length === 7) {
		r = parseInt(hex.substring(1, 3), 16);
		g = parseInt(hex.substring(3, 5), 16);
		b = parseInt(hex.substring(5, 7), 16);
	}

	return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export function getColorAssignments() {
	return colorAssignments;
}

export function buildYAxisConfig(dataArray) {
	const yAxisMap = new Map();

	dataArray.forEach((item) => {
		if (!item) return;

		const key = `${item.valueUnit}-${item.sensorType}`;
		if (!yAxisMap.has(key)) {
			yAxisMap.set(key, {
				uniqueKey: key,
				valueUnit: item.valueUnit,
				sensorType: item.sensorType,
				infrastructureType: item.infraestructureType,
				isRainGauge: item.infraestructureType === 'PLUVIOMETER',
				labels: { format: `{value}${item.valueUnit}` },
				title: { text: `${item.sensorType}` },
			});
		}
	});

	let yAxisArray = Array.from(yAxisMap.values()).sort((a, b) =>
		a.valueUnit?.localeCompare(b.valueUnit),
	);

	yAxisArray = yAxisArray.map((axis) => {
		if (axis.infrastructureType === infraTypes.PLUVIOMETER) {
			return {
				...axis,
				reversed: true,
				opposite: true,
				min: 0,
				showFirstLabel: true,
				showLastLabel: true,
				labels: {
					...axis.labels,
					style: {
						color: '#0066cc',
						fontWeight: 'bold',
						textOverflow: 'none',
						whiteSpace: 'nowrap',
					},
					x: 5,
					y: 5,
					align: 'left',
				},
				title: {
					...axis.title,
					style: {
						color: '#0066cc',
						fontWeight: 'bold',
					},
					align: 'middle',
					margin: 15,
					textAlign: 'center',
					rotation: 270,
					y: 0,
					x: 15,
				},
				marginRight: 10,
				paddingTop: 10,
				marginTop: 10,
			};
		}
		return {
			...axis,
			title: {
				...axis.title,
				rotation: 270,
				align: 'middle',
				style: {
					color: '#666666',
				},
				y: 0,
				x: -10,
			},
			labels: {
				...axis.labels,
				align: 'right',
				style: {
					color: '#666666',
				},
				y: 0,
				x: -15,
			},
			reversed: false,
			opposite: false,
		};
	});

	return yAxisArray;
}

export function buildSeriesData(dataArray, yAxis) {
	const seriesData = [];

	dataArray.forEach((data) => {
		if (!data) return;

		const yAxisIndex = yAxis.findIndex((axis) => axis.valueUnit === data.valueUnit);

		const historical = data.measurementToolHistoricalValues;
		if (historical) {
			const series = Object.keys(historical)
				.map((ts) => ({
					x: parseFloat(ts),
					y: historical[ts].v,
					name: `${data.infrastructureName} ${data.measurementTargetName}`,
					origen: historical[ts].s,
					quality: historical[ts].q,
				}))
				.filter((pt) => pt.y != null)
				.sort((a, b) => a.x - b.x);

			seriesData.push({
				type: 'line',  
				keyname: data.measurementTargetId,
				name: data.infrastructureName,
				serieType: data.originalSourceSerialNumber ? 'source' : 'recommended',
				parameterName: data.measurementTargetName,
				paramId: data.measurementTargetId,
				sourceSerialNumber: data.originalSourceSerialNumber,
				valueUnit: data.valueUnit,
				sensorType: data.sensorType,
				isForecast: false,
				color: generateColor(data.measurementTargetId, data.originalSourceSerialNumber),
				yAxis: yAxisIndex,
				dataGrouping: { enabled: true, units: [['minute', [5]]] },
				lineWidth: 2,
				data: series,
			});
		}

		const forecasts = data.measurementToolForecastValues;
		// Only create forecast series for recommended sources (originalSourceSerialNumber === null)
		if (forecasts && data.originalSourceSerialNumber === null) {
			let indexIteration = 1;

			forecasts.forEach((forecast, idx) => {
				const details = data.measurementToolForecastDetails?.[idx];
				const strategy = details?.strategyName || null;

				const forecastSeries = forecast
					? Object.keys(forecast)
							.map((ts) => ({
								x: parseFloat(ts),
								y: forecast[ts],
								origen: data.serialNumberTool,
								measurementToolForecastDetails: strategy,
							}))
							.filter((pt) => pt.y != null)
							.sort((a, b) => a.x - b.x)
					: [];

				seriesData.push({
					type: 'line',  
					keyname: data.measurementTargetId,
					name: data.infrastructureName,
					serieType: 'forecast',
					parameterName: data.measurementTargetName,
					paramId: data.measurementTargetId,
					sourceName: data.serialNumberTool,
					sourceSerialNumber: data.originalSourceSerialNumber,
					valueUnit: data.valueUnit,
					sensorType: data.sensorType,
					yAxis: yAxisIndex,
					showInLegend: false,
					color: generateColor(data.measurementTargetId, null),
					dashStyle: 'Dash',
					isForecast: true,
					lineWidth: 2,
					indexIteration,
					isPluviometer: forecasts.length > 1,
					forecastIndex: idx,
					dataGrouping: { enabled: true, units: [['minute', [5]]] },
					data: forecastSeries,
				});

				const nextStrategy = data.measurementToolForecastDetails?.[idx + 1]?.strategyName;
				if (strategy !== nextStrategy) {
					indexIteration = 1;
				} else {
					indexIteration++;
				}
			});
		}
	});

	return seriesData;
}
